import { Injectable } from '@angular/core';
import { AlertOptions } from '@ionic/angular';
import { ConfigService, ErrorService, LoggingService, PITEventService, UtilsMisc, ErrorHttp } from '@pit/core';
import { IPinItTrackFrontendErrorService } from '../interfaces/pin.it.track.frontend.error.service.interface';
import { ErrorNotificationService } from './error.notification.service';

@Injectable({
    providedIn: 'root'
})
export class PinItTrackFrontendErrorService extends ErrorService implements IPinItTrackFrontendErrorService {

    constructor(configurationService: ConfigService, loggingService: LoggingService, eventService: PITEventService,
                private errorNotificationService: ErrorNotificationService) {
        super(configurationService, loggingService, eventService);

        this.loggingService.debug('PinItTrackFrontendErrorService --> constructor()');
    }

    protected override async doShowErrorAsync(error: any): Promise<void> {
        if (UtilsMisc.isNullOrUndefined(error) === false) {
            // Check if this is an HTTP error that should show a notification
            if (error instanceof ErrorHttp) {
                // Use the error notification service for HTTP errors
                this.errorNotificationService.showHttpError(error.status, 'operation', null);
            } else {
                // For non-HTTP errors, show a generic error message
                this.eventService.sendEvent('message', {
                    severity: 'error',
                    summary: 'Fehler',
                    detail: error.message || 'Ein unbekannter Fehler ist aufgetreten',
                    sticky: false,
                    life: 5000
                });
            }
        }
    }

}
